import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";
import { State } from "store/reducers";

export const CREATE_TRANSFER = "[TRANSFER CREATE] CREATE_TRANSFER";
export const CREATE_TRANSFER_SUCCESS =
	"[TRANSFER CREATE] CREATE_TRANSFER_SUCCESS";
export const CREATE_TRANSFER_FAILED =
	"[TRANSFER CREATE] CREATE_TRANSFER_FAILED";

export const SET_VALUE = "[TRANSFER CREATE] SET_VALUE";
export const CLEAR_VALUES = "[TRANSFER CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createBankBillet(callback: Callback<IBankBillet>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_TRANSFER });

		try {
			const { login, bankBilletCreate } = getState() as State;

			const {} = bankBilletCreate;

			const errors: any = {};

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {};

			const response = await api.sendPost("/BankBillet", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_TRANSFER_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_TRANSFER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_TRANSFER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
